
export type Agenti = {
  id?: string;
  coddip?: string;
  nomeagente?: string;
  ditta?: number;
  codagente?: string;
}

export type AgentiApiResponse = {
  results: Array<Agenti>;
  count: number;
};

export function mapJsonToAgentiApiResponse(jsonData: any): AgentiApiResponse {
  const mappedData: AgentiApiResponse = {
    count: jsonData.count,
    results: jsonData.results.map((item: any) => ({
        id: item.VBT10_ID,
        coddip: item.VBT10_CODDIP,
        nomeagente: item.VBT10_NOMEAGENTE,
        ditta: item.VBT10_DITTA,
        codagente: item.VBT10_CODAGENTE,
    })),
  };
  return mappedData;
}



export type ReportSospVersore = {
  nrrel?: number;
  ditta?: number;
  nomeditta?: string;
  codprog?: string;
  desprog?: string;
  codcli?: number;
  ragsoccli?: string;
  tipoprog?: string;
  statoprog?: string;
  coddip?: string;
  nomedip?: string;
  codatt?: string;
  desatt?: string;
  codnodo?: string;
  desnodo?: string;
  oreord?: number;
  note?: string;
  datains?: Date | null;
  datareg?: Date | null;
  tiponodo?: string;
  prezzo?: number;
  fatt?: string;
  opzfatt?: string;
  nrfatt?: number;
  annofatt?: number;
  imprigo?: number;
  codart?: string;
  codagente?: string;
  nomeagente?: string;
};

export type ReportSospVersoreApiResponse = {
  results: Array<ReportSospVersore>;
  count: number;
};

export function mapJsonToReportSospVersoreApiResponse(jsonData: any): ReportSospVersoreApiResponse {
  const mappedData: ReportSospVersoreApiResponse = {
    count: jsonData.count,
    results: jsonData.results.map((item: any) => ({
      nrrel: item.VBT57_NRREL,
      ditta: item.VBT57_DITTA,
      nomeditta: item.VBT57_NOMEDITTA,
      codprog: item.VBT57_CODPROG,
      desprog: item.VBT57_DESPROG,
      codcli: item.VBT57_CODCLI,
      ragsoccli: item.VBT57_RAGSOCCLI,
      tipoprog: item.VBT57_TIPOPROG,
      statoprog: item.VBT57_STATOPROG,
      coddip: item.VBT57_CODDIP,
      nomedip: item.VBT57_NOMEDIP,
      codatt: item.VBT57_CODATT,
      desatt: item.VBT57_DESATT,
      codnodo: item.VBT57_CODNODO,
      desnodo: item.VBT57_DESNODO,
      oreord: item.VBT57_OREORD,
      note: item.VBT57_NOTE,
      datains: item.VBT57_DATAINS,
      datareg: item.VBT57_DATAREG,
      tiponodo: item.VBT57_TIPONODO,
      prezzo: item.VBT57_PREZZO,
      fatt: item.VBT57_FATT,
      opzfatt: item.VBT57_OPZFATT,
      nrfatt: item.VBT57_NRFATT,
      annofatt: item.VBT57_ANNOFATT,
      imprigo: item.VBT57_IMPRIGO,
      codart: item.VBT57_CODART,
      codagente: item.VBT57_CODAGENTE,
      nomeagente: item.VBT57_NOMEAGENTE,
    })),
  };

  return mappedData;
}




export type EmailForm = {
    email :string;
    subject :string;
    // message :string;
    attachment :string;
    tipo :string;
  };


export type ReportDateForm = {
                fromDate?     :Date;
                toDate?      :Date;
                emailTo?      :string;
  };





